import { useEffect, useState } from 'react'
import { useAppDispatch, useAppSelector } from 'hooks/store'
import { setTitle } from 'reducers/activecourse/activecourseSlice'
import { CourseTabTitle } from 'share/domain/course'
import CourseTabPlaceOrderUserVerificationForm from 'components/organisms/CourseTabPlaceOrderUserVerificationForm'

const CourseTabPlaceOrderUserVerification = (): JSX.Element => {
  const dispatch = useAppDispatch()
  const activeCourse = useAppSelector((state) => state.activeCourse)
  const [courseName, setCourseName] = useState('first')

  useEffect(() => {
    let title = ''
    if (activeCourse?.activeTab) {
      title =
        activeCourse.activeTab === 'first'
          ? CourseTabTitle.TAKE_FIRST_COURSE
          : CourseTabTitle.TAKE_SECOND_COURSE
    }

    if (activeCourse?.activeTab === 'second') {
      setCourseName('second')
    }

    dispatch(setTitle(title))
  }, [activeCourse?.activeTab])

  return (
    <div>
      <h2>User Verification</h2>
      <h4>
        Please enter your social security number to order your {courseName}{' '}
        course
      </h4>
      <CourseTabPlaceOrderUserVerificationForm />
    </div>
  )
}

export default CourseTabPlaceOrderUserVerification
